import script from "./RichTextToolbar.vue?vue&type=script&setup=true&lang=js"
export * from "./RichTextToolbar.vue?vue&type=script&setup=true&lang=js"

import "./RichTextToolbar.vue?vue&type=style&index=0&id=083dc0e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-083dc0e4"]])

export default __exports__